/* unplugin-vue-components disabled */import script from "./MenuBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuBlock.vue?vue&type=script&setup=true&lang=ts"

import "./MenuBlock.vue?vue&type=style&index=0&id=dd1964c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd1964c0"]])

export default __exports__